import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function AddNewOfficials() {
    const { id: cogen_id } = useParams(); // Get cogen_id from URL

    const [formData, setFormData] = useState({
        designation: '',
        officials_name: '',
        officials_email: '',
        mobile_no: '',
        phone_number: '',
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        let tempErrors = {};
        let isValid = true;

        if (!formData.designation.trim()) {
            tempErrors.designation = 'Designation is required.';
            isValid = false;
        }
        if (!formData.officials_name.trim()) {
            tempErrors.officials_name = 'Official\'s Name is required.';
            isValid = false;
        }
        if (formData.officials_email && !/\S+@\S+\.\S+/.test(formData.officials_email)) {
            tempErrors.officials_email = 'Enter a valid email address.';
            isValid = false;
        }
        if (!formData.mobile_no.trim()) {
            tempErrors.mobile_no = 'Mobile Number is required.';
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validate()) {
            try {
                await axios.post(`https://backend-zkgn.onrender.com/api/cogen_officials`, {
                    cogen_id,
                    ...formData,
                });

                setSuccessMessage('Official Added Successfully!');
                setTimeout(() => setSuccessMessage(''), 3000);

                setFormData({
                    designation: '',
                    officials_name: '',
                    officials_email: '',
                    mobile_no: '',
                    phone_number: '',
                });
            } catch (error) {
                console.error('Error submitting form:', error.message);
            }
        }
    };

    return (
        <div className="container my-5">
            <h4 className="mb-4 text-center">Add Plant Official</h4>

            {successMessage && (
                <div className="alert alert-success text-center" role="alert">
                    {successMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Designation</label>
                        <input
                            type="text"
                            className="form-control"
                            name="designation"
                            value={formData.designation}
                            onChange={handleChange}
                        />
                        {errors.designation && <small className="text-danger">{errors.designation}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Official's Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="officials_name"
                            value={formData.officials_name}
                            onChange={handleChange}
                        />
                        {errors.officials_name && <small className="text-danger">{errors.officials_name}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Official's Email (Optional)</label>
                        <input
                            type="email"
                            className="form-control"
                            name="officials_email"
                            value={formData.officials_email}
                            onChange={handleChange}
                        />
                        {errors.officials_email && <small className="text-danger">{errors.officials_email}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Mobile Number</label>
                        <input
                            type="text"
                            className="form-control"
                            name="mobile_no"
                            value={formData.mobile_no}
                            onChange={handleChange}
                        />
                        {errors.mobile_no && <small className="text-danger">{errors.mobile_no}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Phone Number (Optional)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-primary px-4">Add Plant Official</button>
                </div>
            </form>
        </div>
    );
}

export default AddNewOfficials;
